<template>
    <tr :class="{'deleted' : invoice.car == null}">
        <td class="link" @click="openModal">#{{ invoice.id }}</td>
        <td class="link" @click="openModal">{{ invoice.issued_date }}</td>
        <td class="link" @click="openModal">{{ invoice.user.name }}</td>
        <td class="link" @click="openModal">{{ invoice.incharge }}</td>
        <td class="link" @click="openModal">{{ invoice.sale_jpy | formatNumber }}</td>
        <td class="link" @click="openModal">{{ invoice.cost_jpy | formatNumber }}</td>
        <td class="link" v-if="invoice.car != null" @click="openModal">{{ invoice.sale_jpy - invoice.cost_jpy | formatNumber }}</td>
        <td v-else>DELETED</td>
        <td class="link" :class="{'has-text-success': invoice.locked, 'has-text-danger': !invoice.locked}" @click="openModal">{{ invoice.locked ? 'LOCKED' : 'UNLOCKED' }}</td>
        <td v-if="isAdmin">{{ invoice.zoho_id != null ? 'yes' : 'no' }}</td>
        <td v-if="isAdmin"><action-column :car="invoice.car" :invoice="invoice"></action-column></td>
        <proforma-invoice-modal :car="invoice.car" :invoice="invoice" v-if="isActive"></proforma-invoice-modal>
        <alert-car-modal></alert-car-modal>
    </tr>
</template>

<script>
    import ProformaInvoiceModal from './../../Cars/Columns/ProformaInvoice/ProformaInvoiceModal'
    import ActionColumn from "./../../Cars/Columns/ActionColumn";
    import AlertCarModal from "../../Cars/AlertCarModal";
    export default {
        props: ['invoice'],
        components: {
            AlertCarModal,
            ActionColumn,
            ProformaInvoiceModal
        },
        computed: {
            isAdmin() {
                if (this.$store.getters.getUserRole === 'Admin') {
                    return true
                }
            },
            isActive() {
                if (this.invoice.car != null) {
                    return this.$store.getters.getProformaInvoiceModalStatus(this.invoice.car.id)
                }
            },
            isLoading() {
                return this.$store.getters.getLoaderStatus
            }
        },
        methods: {
            openModal() {
                this.$store.dispatch('changeProformaInvoiceModalStatus', { status: true, carId: this.invoice.car.id })
                this.$store.dispatch('fetchProformaInvoice', this.invoice.car.id)
            },
        }
    }
</script>

<style scoped>
    td {
        font-size: 10px;
        font-weight: bold;
    }
    .link {
        cursor: pointer;
    }
    .deleted {
        background-color: rgba(206, 39, 45, 0.31) !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/ControlPanel/Profit/ProfitInvoiceTableRow.vue